import { Chip } from "@mui/material";
import {
  APPLICATION_STATUS_CHIP_SX,
  getApplicationStatusStyle,
} from "../../constants/statusStyles";

const ApplicationStatusChip = ({ status, label = status, sx, ...props }) => (
  <Chip
    label={label}
    size="small"
    sx={[
      APPLICATION_STATUS_CHIP_SX,
      sx,
      getApplicationStatusStyle(status) || {},
    ]}
    {...props}
  />
);

export default ApplicationStatusChip;
